import {
  Identifiable,
  project,
  Project,
  ProjectElementType,
  resource,
  Resource,
  ResourceTypes,
  Task,
} from "@planzone/dto";

type TimeRecord = {
  date: number;
  month: number;
  year: number;
  timeSpent: number;
  resource: Identifiable<Resource>;
  task: Identifiable<Task>;
  attributes?: { [key: string]: string };
  recordingDay?: string;
};

type SpentTime = {
  date: string;
  time: number;
  isAvailable: boolean;
};

type OptimizedTimeSheet = {
  resource: Identifiable<Resource>;
  project: Identifiable<Project>;
  integratedAt: string;
  isResourceInProject: boolean;
  totalOfAllocatedHours: number;
  totalOfSpentTime: number;
  totalOfSpentTimeInWeek: number;
  totalOfSpentTimeUntilEndDate: number;
  totalOfRemainingTime: number;
  percentCompletion: number;
  spentTimes: SpentTime[];
  elements: (
    | {
        type: ProjectElementType.LIST;
        uuid: string;
        name: string;
        depth: number;
        keyRank: number;
        parentUuid: string;
        spentTimes: SpentTime[];
        totalOfAllocatedHours: number;
        totalOfSpentTime: number;
        totalOfSpentTimeInWeek: number;
        totalOfSpentTimeUntilEndDate: number;
        totalOfRemainingTime: number;
        percentComplete: number;
        timeRecords: Identifiable<TimeRecord>[];
        resourceHaveAllocation: null;
        taskResourceLatestRecordingDay: null;
        taskResourceLatestRecord: null;
        allocationData: null;
        endDate: string;
        startDate: string;
        attributes: { [key: string]: string };
        resourcePercentComplete: number | null;
        nbrComments: number;
      }
    | {
        type: ProjectElementType.TASK;
        uuid: string;
        name: string;
        depth: number;
        keyRank: number;
        parentUuid: string;
        spentTimes: SpentTime[];
        totalOfAllocatedHours: number;
        totalOfSpentTime: number;
        totalOfSpentTimeInWeek: number;
        totalOfSpentTimeUntilEndDate: number;
        totalOfRemainingTime: number;
        percentComplete: number;
        timeRecords: Identifiable<TimeRecord>[];
        resourceHaveAllocation: boolean;
        taskResourceLatestRecordingDay: null | string;
        taskResourceLatestRecord: null | string;
        allocationData: {
          uuid: string;
          resourceUuid: string;
          percentComplete: number;
          allocatedHours: number;
        }[];
        endDate: string;
        startDate: string;
        attributes: { [key: string]: string };
        resourcePercentComplete: number;
        nbrComments: null | number;
      }
  )[];
};

const optimizedTimeSheet: OptimizedTimeSheet = {
  resource: { ...resource, uuid: "" },
  project: { ...project, uuid: "" },
  integratedAt: "",
  isResourceInProject: false,
  totalOfAllocatedHours: 0,
  totalOfSpentTime: 0,
  totalOfSpentTimeInWeek: 0,
  totalOfSpentTimeUntilEndDate: 0,
  totalOfRemainingTime: 0,
  percentCompletion: 0,
  spentTimes: [],
  elements: [],
};

export type { OptimizedTimeSheet };

export { optimizedTimeSheet };
